import LOCALE from '@/common/locale'
import LOCALE_AMENITY from '@/common/locale_amenity'

// 브라우저 설정 언어를 서비스 기본 언어로 설정
const navigatorLang = window.navigator.language
// 언어 코드별 매칭할 값 (= locale 파일명)
const langCode = {
  'ko': 'ko',
  'ko-KR': 'ko',
  'en': 'en',
  'en-US': 'en',
  'ja': 'ja'
}
const getLocale = langToCode(navigatorLang)

// return { term: definition, term: definition, ... }
function localeData (ln) {
  let obj = {}
  LOCALE[ln].forEach(x => {
    obj[x.term] = x.definition
  })
  return obj
}
function localeAmenityData (ln) {
  let obj = {}
  LOCALE_AMENITY[ln].forEach(x => {
    obj[x.term] = x.definition
  })
  return obj
}
function langToCode (lang) {
  return langCode[lang] ? langCode[lang] : 'en'
}

export default {
  namespaced: true,
  state: {
    version: process.env.VUE_APP_VERSION,
    updated: process.env.VUE_APP_UPDATED,
    locale: {
      list: Object.keys(LOCALE),
      default: getLocale,
      data: localeData(getLocale)
    },
    localeAmenity: {
      list: Object.keys(LOCALE_AMENITY),
      default: getLocale,
      data: localeAmenityData(getLocale)
    },
    partner: null
  },
  mutations: {
    setLocale (state, data) {
      state.locale.default = data
      state.locale.data = localeData(data)
      state.localeAmenity.default = data
      state.localeAmenity.data = localeAmenityData(data)
      document.getElementsByTagName('html')[0].setAttribute('lang', data)
      localStorage.setItem('lang', data)
    },
    setPartner (state) {
      const getHost = function (host) {
        if (host.includes('coreguide')) {
        // if (host.includes('8080')) {
          document.title = 'CoreGuide:: editor'
          return 'NSJ'
        } else {
          return null
        }
      }
      state.partner = getHost(window.location.host)
    }
  },
  actions: {
  },
  getters: {
    getLocale: state => state?.locale?.data
  }
}
